import { takeEvery, put, call } from "redux-saga/effects";
import {
  getLandingList,
  getStopsList,
  setLandingList,
  setStopsList,
  updateLandingList
} from "../actions/landingListAction";
import { getLandingListRequest } from "../../api/LandingList/getLandingListRequest";
import { getStopsListRequest } from "../../api/LandingList/getStopsListRequest";
import { updateLandingListRequest } from "../../api/LandingList/updateLandingListRequest";

function* getLandingListSaga(action) {
  try {
    const { orderId } = action.payload;
    const { pagination } = action.payload;
    const { sort } = action.payload;
    const response = yield call(
      getLandingListRequest,
      orderId,
      pagination,
      sort
    );
    if (response.status === 200) {
      yield put(setLandingList(response.data));
    }
  } catch (e) {
    console.log(e);
  }
}

function* getStopsListSaga(action) {
  try {
    const orderId = action.payload;
    const response = yield call(getStopsListRequest, orderId);
    if (response.status === 200) {
      yield put(setStopsList(response.data));
    }
  } catch (e) {
    console.log(e);
  }
}

function* updateLandingListSaga(action) {
  try {
    const response = yield call(updateLandingListRequest, action.payload);
    if (response.status === 200) {
      yield put(getLandingList(action.payload.orderId));
    }
  } catch (e) {
    console.log(e);
  }
}

export function* landingListWatcher() {
  yield takeEvery(getLandingList.toString(), getLandingListSaga);
  yield takeEvery(getStopsList.toString(), getStopsListSaga);
  yield takeEvery(updateLandingList.toString(), updateLandingListSaga);
}
